import React, { useState, useRef, useEffect } from "react";
import { Link } from "react-router-dom";
import { GlobalSet } from '../../global/GlobalProvider';
import { Button, Modal, Form } from 'react-bootstrap';
import axios from "axios";
import swal from "sweetalert";
import { useTranslation } from 'react-i18next';

const BasicDatatable = () => {
  const { t } = useTranslation();
  const { CurrencySymbol } = GlobalSet();
  const [data, setData] = useState([]);
  const sort = 5;
  const activePag = useRef(0);

  const [income, setIncome] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [selectedItemId, setSelectedItemId] = useState(null);
  const [ModalGet, setModalGet] = useState([]);
  const [selectedPlan, setSelectedPlan] = useState(null);

  const plans = [
    { id: 1, duration: "6 Months", rate: 9 },
    { id: 2, duration: "1 Years", rate: 10 },
    { id: 3, duration: "2 Years", rate: 12 },
  ];

  const fetchData = () => {
    const selectedCurrency = localStorage.getItem('selectedCurrency');
    const auth_token = localStorage.getItem('auth_token');
    const requestData = { key_s: 'eyJ0eXAiOiJKV1Qidfg%!#%$%LCdf#*&*JhbGciOiJSUzI1NiJ9', currency: selectedCurrency };
    if (auth_token) {
      axios.post('/apps-migration-log', requestData)
        .then(response => setIncome(response.data.data))
        .catch(error => console.log(error));
    }
  };

  useEffect(() => { fetchData(); }, []);

  // Pagination logic
  const chageData = (frist, sec) => {
    for (let i = 0; i < data.length; i++) {
      if (i >= frist && i < sec) data[i].classList.remove("d-none");
      else data[i].classList.add("d-none");
    }
  };

  useEffect(() => {
    setData(document.querySelectorAll("#job_data tbody tr"));
  }, [income]);

  activePag.current === 0 && chageData(0, sort);

  const onClickPage = (i) => {
    activePag.current = i;
    chageData(activePag.current * sort, (activePag.current + 1) * sort);
  };

  const handleOpenModal = (itemId) => {
    const selectedCurrency = localStorage.getItem('selectedCurrency');
    const auth_token = localStorage.getItem('auth_token');
    const requestData = { key_s: 'eyJ0eXAiOiJKV1Qidfg%!#%$%LCdf#*&*JhbGciOiJSUzI1NiJ9', draft_rand: itemId, currency: selectedCurrency };
    if (auth_token) {
      axios.post('/get-check-principal', requestData)
        .then(response => setModalGet(response.data.data))
        .catch(error => console.log(error));
    }
    setSelectedItemId(itemId);
    setSelectedPlan(null);
    setShowModal(true);
  };

  const handleCloseModal = () => {
    setSelectedItemId(null);
    setSelectedPlan(null);
    setShowModal(false);
  };

// Refund API call with confirmation
const handleRefund = () => {
  swal({
    title: "Are you sure?",
    text: `Do you really want to refund $${ModalGet.fixt_amount}?`,
    icon: "warning",
    buttons: ["Cancel", "Yes, Refund!"],
    dangerMode: true,
  }).then((willRefund) => {
    if (willRefund) {
      const selectedCurrency = localStorage.getItem('selectedCurrency');
      const auth_token = localStorage.getItem('auth_token');
      const requestData = { 
        key_s: 'eyJ0eXAiOiJKV1Qidfg%!#%$%LCdf#*&*JhbGciOiJSUzI1NiJ9', 
        draft_rand: selectedItemId, 
        currency: selectedCurrency.replace(/"/g,'') 
      };
      if (auth_token) {
        axios.post('/get-refund-principal', requestData)
          .then(response => {
            if (response.data.status === 'success') {
              swal("Success", response.data.message, "success");
              fetchData();
            } else {
              swal("Warning", response.data.message || "Server problem", "warning");
            }
          })
          .catch(error => console.log(error));
      }
      handleCloseModal();
    }
  });
};


const canceleRefund = () => {
  swal({
    title: "Are you sure?",
    text: `Do you really want to Cancel Refund $${ModalGet.fixt_amount}?`,
    icon: "warning",
    buttons: ["Cancel", "Yes, Cancel Refund!"],
    dangerMode: true,
  }).then((willRefund) => {
    if (willRefund) {
      const selectedCurrency = localStorage.getItem('selectedCurrency');
      const auth_token = localStorage.getItem('auth_token');
      const requestData = { 
        key_s: 'eyJ0eXAiOiJKV1Qidfg%!#%$%LCdf#*&*JhbGciOiJSUzI1NiJ9', 
        draft_rand: selectedItemId, 
        currency: selectedCurrency.replace(/"/g,'') 
      };
      if (auth_token) {
        axios.post('/get-refund-cancel', requestData)
          .then(response => {
            if (response.data.status === 'success') {
              swal("Success", response.data.message, "success");
              fetchData();
            } else {
              swal("Warning", response.data.message || "Server problem", "warning");
            }
          })
          .catch(error => console.log(error));
      }
      handleCloseModal();
    }
  });
};


  // Update Plan API call
  const handleUpdatePlan = () => {
    if (!selectedPlan) {
      swal("Warning", "Please select a plan before updating.", "warning");
      return;
    }
    const selectedCurrency = localStorage.getItem('selectedCurrency');
    const auth_token = localStorage.getItem('auth_token');
    const requestData = { 
      key_s: 'eyJ0eXAiOiJKV1Qidfg%!#%$%LCdf#*&*JhbGciOiJSUzI1NiJ9', 
      draft_rand: selectedItemId,
      currency: selectedCurrency.replace(/"/g,''),
      plan_id: selectedPlan };
    if (auth_token) {
      axios.post('/fixed-plan-update', requestData)
        .then(response => {
          if (response.data.status === 'success') {
            swal("Success", response.data.message, "success");
            fetchData();
          } else {
            swal("Warning", response.data.message || "Server problem", "warning");
          }
        })
        .catch(error => console.log(error));
    }
    handleCloseModal();
  };

  return (
    <div className="col-12">
      <div className="card">
        <div className="card-header"><h4 className="card-title">Invest Log</h4></div>
        <div className="card-body">
          <div className="table-responsive">
            <div id="job_data" className="dataTables_wrapper">
              <table className="display w-100 dataTable" id="example5">
                <thead>
                  <tr>
                    <th>SL</th>
                    <th>Invest Amount</th>
                    <th>Total Return</th>
                    <th>Invest Status</th>
                    <th>Invest Time</th>
                    <th>Action</th>
                  </tr>
                </thead>
                <tbody>
                  {income.map((incomerow,index) => (
                    <tr key={incomerow.id}>
                      <td>{index+1}</td>
                      <td>${incomerow.fixt_amount}</td>
                      <td>${incomerow.back_amount}</td>
                      <td>
                        {(() => {
                          switch (incomerow.status) {
                            case 0:
                              return <span className="badge bg-warning">Inactive</span>;
                            case 1:
                              return <span className="badge bg-success">Active</span>;
                            case 2:
                              return <span className="badge bg-dark">Refunded</span>;
                            case 3:
                              return <span className="badge bg-info">Processing</span>;
                            default:
                              return <span className="badge bg-dark">Unknown</span>;
                          }
                        })()}
                      </td>

                      <td>{incomerow.create_date}</td>
                      <td>
                         <button className="btn btn-success btn-rounded" onClick={()=>handleOpenModal(incomerow.draft_rand)}>Details</button>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>

              {/* Pagination */}
              <div className="d-sm-flex justify-content-between align-items-center mt-3 mb-md-0 mb-2">
                <div className="dataTables_info">
                  Showing {activePag.current*sort+1} to {data.length > (activePag.current+1)*sort?(activePag.current+1)*sort:data.length} of {data.length} entries
                </div>
                <div className="dataTables_paginate paging_simple_numbers mb-0">
                  <Link className="paginate_button previous disabled" to="#" onClick={()=>activePag.current>0 && onClickPage(activePag.current-1)}><i className="fa fa-angle-double-left"></i></Link>
                  {Array.from({length: Math.ceil(data.length/sort)}, (_, i) => (
                    <Link key={i} to="#" className={`paginate_button ${activePag.current===i?"current":""}`} onClick={()=>onClickPage(i)}>{i+1}</Link>
                  ))}
                  <Link className="paginate_button next" to="#" onClick={()=>activePag.current+1<Math.ceil(data.length/sort) && onClickPage(activePag.current+1)}><i className="fa fa-angle-double-right"></i></Link>
                </div>
              </div>

            </div>
          </div>
        </div>
      </div>
      {/* Modal */}
      <Modal show={showModal} onHide={handleCloseModal}>
        <Modal.Header closeButton>
          <Modal.Title>Refund / Update Plan</Modal.Title>
        </Modal.Header>

        <Modal.Body>
          <p>Refundable Balance: ${ModalGet.fixt_amount}</p>

          {/* Status Handling */}
          {ModalGet.status === 0 && (
            <Button
              style={{ float: 'right', marginTop: '-39px' }}
              variant="danger"
              onClick={canceleRefund}
            >
              Cancel Refund
            </Button>          
          )}

          {ModalGet.status === 1 && (
            <Button
              style={{ float: 'right', marginTop: '-39px' }}
              variant="danger"
              onClick={handleRefund}
            >
              Fully Fund Refund
            </Button>
          )}

          {ModalGet.status === 2 && (
            <Button
              style={{ float: 'right', marginTop: '-39px' }}
              variant="danger"
            >
              Refunded
            </Button> 
          )}

          {ModalGet.status === 3 && (
            <Button
              style={{ float: 'right', marginTop: '-39px' }}
              variant="danger"
            >
              Inactive
            </Button>  
          )}

          {!([0, 1, 2, 3].includes(ModalGet.status)) && (
            <span className="badge bg-dark">Unknown</span>
          )}

          {/* Plan Selection */}
          <h6 className="mt-3">Select a Plan:</h6>
          {plans.map(plan => {
            let duration_val = null;
            if (ModalGet.duration === 182) duration_val = 1;
            else if (ModalGet.duration === 365) duration_val = 2;
            else if (ModalGet.duration === 730) duration_val = 3;

            const isSelected =
              selectedPlan === plan.id ||
              (selectedPlan === null && plan.id === duration_val);

            return (
              <div
                key={plan.id}
                onClick={() => setSelectedPlan(plan.id)}
                style={{
                  border: isSelected ? '2px solid #007bff' : '1px solid #ccc',
                  borderRadius: '5px',
                  padding: '8px',
                  marginBottom: '5px',
                  cursor: 'pointer',
                  backgroundColor: isSelected ? '#e7f1ff' : '#fff',
                }}
              >
                <Form.Check
                  type="radio"
                  label={`${plan.duration} – ${plan.rate}%`}
                  name="refundPlan"
                  value={plan.id}
                  checked={isSelected}
                  onChange={() => setSelectedPlan(plan.id)}
                />
              </div>
            );
          })}
        </Modal.Body>

        <Modal.Footer>
          <Button variant="secondary" onClick={handleCloseModal}>
            Cancel
          </Button>
          <Button variant="warning" onClick={handleUpdatePlan}>
            Update Plan
          </Button>
        </Modal.Footer>
      </Modal>



    </div>
  );
};

export default BasicDatatable;
